var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ac-simple-label',{attrs:{"data":_vm.data_send},scopedSlots:_vm._u([{key:"title",fn:function(ref){
var data = ref.data;
return [_vm._v("\n    "+_vm._s(data)+"\n  ")]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }